import { render, staticRenderFns } from "./RelatedLanguages.vue?vue&type=template&id=3d87a6f9&"
import script from "./RelatedLanguages.vue?vue&type=script&lang=js&"
export * from "./RelatedLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports